import InPlaceError from "components/in-place-error/InPlaceError";
import React, { useEffect, useState } from "react";
import "./date-input.scss";
import { Label } from "components/ui/input/Input";
import WarningMessage from "components/ui/warning-message/WarningMessage";
import { getYearDifferenceWithoutDay } from "utilities/date";
import { ALLOWED_YEAR_START_VALUE, DATE_LIMIT_WARNING_MESSAGE, YEAR_WARNING_LIMIT_VALUE } from "utilities/Constant";

export interface DateInputProps {
  errorMessage?: string;
  onChange?: (e: string) => void;
  placeholder?: string;
  label?: string;
  initialValue: string;
}

const DateInput = ({
  errorMessage,
  onChange,
  placeholder,
  label,
  initialValue,
}: DateInputProps) => {
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const [showWarning, setShowWarning] = useState(false);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value;
    const sanitizedValue = rawValue.replace(/\D/g, "");
    let formattedValue = "";

    const month = Number.parseInt(sanitizedValue.slice(0, 2), 10);
    const year = Number.parseInt(sanitizedValue.slice(2, 6), 10);

    if (sanitizedValue.length > 2) {
      formattedValue = `${month.toString().padStart(2, "0")}/${year}`;
    } else {
      formattedValue = sanitizedValue;
    }
    setInputValue(formattedValue);

    if (rawValue.length > 6) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const yearDifference = getYearDifferenceWithoutDay(new Date(year, month-1), currentDate) ;
      if ( yearDifference >= YEAR_WARNING_LIMIT_VALUE && year >= ALLOWED_YEAR_START_VALUE && (year < currentYear )) {
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
    } else {
      setShowWarning(false);
    }

    if (onChange) {
      onChange(formattedValue);
    }
  };

  return (
    <div className="dateinput-container">
      {showWarning && !errorMessage && <WarningMessage message={DATE_LIMIT_WARNING_MESSAGE} />}
      {label && <Label label={label} />}
      <div className="dateinput-container__wrapper">
        <input
          className={errorMessage ? "dateinput dateinput--error" : "dateinput"}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
        />
        {(errorMessage) && (
          <InPlaceError errorPhrase={errorMessage} />
        )}
      </div>
    </div>
  );
};
export default DateInput;